module.exports = {
  REACT_APP_API_ENDPOINT:
    process.env.REACT_APP_API_ENDPOINT || "https://api.finportpulse.com/v1",
  // "https://api.finportmasterclass.com/v1",
  // "http://localhost:8001/v1",
  // "http://172.16.50.81:8001/v1",
  // "http://172.16.41.168:8001/v1",
  // "http://172.16.40.25:8001/v1",
  // "http://172.16.50.154:8001/v1",
  // "http://172.16.50.59:8001/v1",
  // "http://172.16.50.148:8001/v1",
  // "http://192.168.0.39:8001/v1",
  // "https://finport-be.sernsoft.com/v1",
  AIGC_EXTERNAL_API_ENDPOINT:
    process.env.AIGC_EXTERNAL_API_ENDPOINT ||
    "https://gpt-api-stg.sernsoft.com", //"http://localhost:8005",
  REACT_APP_S3_BUCKET_PRESIGN_URL:
    process.env.REACT_APP_S3_BUCKET_PRESIGN_URL ||
    "https://ml8o8u2sdl.execute-api.ap-southeast-1.amazonaws.com/prd/presigned-post-data",
  PORT: process.env.PORT || "8000",
};
